'use strict';

var _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

var Blockly = require('../../lib/blockly_compressed');

Blockly.Msg = _.extend(require('../../lib/i18n/en'), Blockly.Msg);
Blockly.Msg = Blockly.Msg();

module.exports = Blockly;
